<app-header-n (scroll)="onWindowScroll($event);" (modalSelect)="listenChangesOfHeader($event)"></app-header-n>
<div>
    <ngx-spinner bdColor="rgba(206,58,6,0.8)" size="medium" color="#fff" type="ball-newton-cradle" [fullScreen]="true">
        <p style="color: white !important"> Loading... </p>
    </ngx-spinner>
</div>
<div class="container">
    <div class="row">
        <div class="col">
            <div class="c-reg">
                <div class="alert alert-success" *ngIf="succes">
                    <strong class="default"><i class="far fa-check-circle"></i> Te has registrado exitosamente!</strong>
                    <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                </div>
                <div class="alert alert-info" *ngIf="succes">
                    <strong class="default"><i class="far fa-check-circle"></i> Su clave por defecto: 123</strong>
                    <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                </div>
                <div class="lider-container">
                    <mat-label><b>Formulario Mensajeros</b>
                    </mat-label>
                </div>
                <mat-vertical-stepper *ngIf="isVisible" [linear]="isLinear" #stepper>
                    <mat-step [stepControl]="registroFormGroup1">
                        <form [formGroup]="registroFormGroup1">
                            <div>
                                <ng-template matStepLabel><span class="te-si">Datos personales </span></ng-template>
                                <p>
                                    <mat-form-field class="nombre-campo">
                                        <mat-label>Nombre completo</mat-label>
                                        <input matInput placeholder="ingresa tu nombre y apellido" maxlength="45" formControlName="nombreCompleto" required>
                                        <mat-error *ngIf="getControl('nombreCompleto' , 1).errors">Nombre completo incorrecto
                                        </mat-error>
                                    </mat-form-field>

                                    <mat-form-field class="usuario-campo">
                                        <mat-label>Usuario</mat-label>
                                        <input matInput placeholder="usuario" maxlength="15" formControlName="usuario" [(ngModel)]="nombreUsu" required>
                                        <mat-error *ngIf="getControl('usuario' , 1).errors">Usuario ya existe
                                        </mat-error>
                                    </mat-form-field>
                                </p>

                                <p>
                                    <mat-form-field class="email-campo">
                                        <mat-label>Email</mat-label>
                                        <input matInput placeholder="Email" formControlName="email" required>
                                        <mat-error *ngIf="getControl('email' , 1).errors">Email incorrecta</mat-error>
                                    </mat-form-field>
                                </p>

                                <p>
                                    <mat-form-field class="direccion-campo">
                                        <mat-label>Direccion</mat-label>
                                        <input matInput placeholder="Dirección" maxlength="45" formControlName="direccion" required>
                                        <mat-error *ngIf="getControl('direccion' , 1).errors">Dirección incorrecta
                                        </mat-error>
                                    </mat-form-field>
                                </p>
                                <p>
                                    <mat-form-field class="pais-campo">
                                        <mat-select formControlName="pais" [(value)]="selectPais" (ngModelChange)="selectPaisChange($event)" class="pais-selected" style="background-image: url({{selectPais?.url_bandera}});">
                                            <mat-option *ngFor="let pais of paises" [value]="pais">
                                                <img style="width: 5vw;" [src]="pais.url_bandera" alt="">{{pais.pais}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field class="ciudad-campo">
                                        <mat-error *ngIf="getControl('ciudad' , 1).errors">Ciudad incorrecta</mat-error>
                                        <mat-label>Ciudad</mat-label>
                                        <mat-select formControlName="ciudad" required>
                                            <mat-option *ngFor="let option of Cities" [value]="option.ciudad" (onSelectionChange)="onSelectedOption(option, $event)">
                                                {{option.ciudad}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </p>
                                <p>
                                    <mat-form-field class="telefono-campo">
                                        <mat-label>Teléfono</mat-label>
                                        <input matInput placeholder="Teléfono" maxlength="12" pattern="\d*" formControlName="telefono" required>
                                        <mat-error *ngIf="getControl('telefono' , 1).errors">Teléfono incorrecto
                                        </mat-error>
                                    </mat-form-field>
                                </p>

                            </div>

                            <div>
                                <mat-label>Foto de Perfil</mat-label>
                                <input type="file" (change)="fileChangeEvent($event)" formControlName="imagen" accept="image/x-png,image/gif,image/jpeg" required /> &nbsp;&nbsp;
                                <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="1 / 1" [resizeToWidth]="200" [imageQuality]="100" format="png" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()"
                                    (loadImageFailed)="loadImageFailed()">
                                </image-cropper>
                                <img [src]="croppedImage" style="padding-bottom: 1vw;" />
                                <mat-error *ngIf="getControl('imagen' , 1).errors">Sube una imagen*
                                </mat-error>
                            </div>

                            <div>
                                <button mat-button matStepperNext>Continuar</button>
                            </div>
                        </form>
                    </mat-step>
                    <mat-step [stepControl]="registroFormGroup2">
                        <form [formGroup]="registroFormGroup2">
                            <ng-template matStepLabel><span class="te-si">Datos del Vehiculo</span></ng-template>
                            <p>
                                <mat-form-field class="placa-campo">
                                    <mat-label>Placa del vehiculo</mat-label>
                                    <input matInput placeholder="Placa del vehiculo" maxlength="6" formControlName="placa" required>
                                    <mat-error *ngIf="getControl('placa' , 2).errors">Placa incorrecta</mat-error>
                                </mat-form-field>
                            </p>
                            <!--<p>
                                <mat-form-field class="medio-transporte-campo">
                                    <mat-label>Cual es tu medio de transporte</mat-label>
                                    <input matInput placeholder="...moto, carro, bici, scooter" matInput formControlName="medioTransporte" required [matAutocomplete]="auto2">
                                    <mat-autocomplete #auto2="matAutocomplete">
                                        <mat-option *ngFor="let trans of medioTransporte" [value]="trans" (onSelectionChange)="onSelectedOption2(trans)">
                                            {{trans}}
                                        </mat-option>
                                    </mat-autocomplete>
                                    <mat-error *ngIf="getControl('medioTransporte' , 2).errors">Medio de transporte incorrecto
                                    </mat-error>
                                </mat-form-field>

                            </p>-->
                            <div>
                                <button mat-button matStepperPrevious>Volver</button>
                                <button mat-button matStepperNext>Continuar</button>
                            </div>
                        </form>
                    </mat-step>
                    <mat-step>
                        <ng-template matStepLabel><span class="te-si">Completo</span></ng-template>
                        <p>Informacion completa</p>
                        <div>
                            <button mat-button matStepperPrevious>Volver</button>
                            <button mat-button (click)="stepper.reset()">Limpiar informacion</button>
                            <button mat-button (click)="saveInfo()">Guardar</button>
                        </div>
                    </mat-step>
                </mat-vertical-stepper>
            </div>

        </div>
        <div class="col info-col">
            <p class="title">
                <b><span class="triidy-color">Triidy entregas</span></b>
            </p>
            <p class="info">Establece tu propia ruta de entregas, gestiona tu tiempo e incrementar tus ingresos
            </p>
            <!--<div>
                <input type="file" (change)="fileChangeEvent($event)" /> &nbsp;&nbsp;
                <button (click)="save()">Guardar cambios</button>
                <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="1 / 1" [resizeToWidth]="200" [imageQuality]="100" format="png" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()"
                    (loadImageFailed)="loadImageFailed()">
                </image-cropper>
                <img [src]="croppedImage" />
            </div>-->
            <div class="cont-img">
                <img src="https://seguros.sura.cl/docs/default-source/landing-seguro-motos/motociclista.png" alt="">
            </div>
        </div>
    </div>
</div>
<app-footer-n></app-footer-n>

<app-modal-reg *ngIf="vistaRegistro" (modalSelect)="closeModal($event)"></app-modal-reg>